import { Injectable } from '@angular/core';
import { TemplateConfig } from '../template-config/config.interface';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    public templateConf: TemplateConfig;

    constructor( ) {
        this.setConfigValue();
    }

    setConfigValue() {
        this.templateConf = {
            layout: {
                variant: 'Light', // options:  Dark, Light & Transparent
                dir: 'ltr', // Options: ltr, rtl
                sidebar: {
                    collapsed: false, // options: true, false
                    size: 'sidebar-sm', // Options: 'sidebar-lg', 'sidebar-md', 'sidebar-sm'
                    // Options: 'black', 'pomegranate', 'king-yna', 'ibiza-sunset', 'flickr', 'purple-bliss', 'man-of-steel', 'purple-love'
                    backgroundColor: 'man-of-steel',
                    backgroundImage: true, // Options: true, false | Set true to show background image
                    backgroundImageURL: environment.branding.sidebarBackgroundUrl
                }
            }
        };
    }



}
